import { type Plugin } from "@nuxt/types";

interface FeatureDetection {
  webp: boolean;
  dpr: number;
  clipboard: boolean;
}

declare module "vue/types/vue" {
  interface Vue {
    $featureDetection: FeatureDetection;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $featureDetection: FeatureDetection;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $featureDetection: FeatureDetection;
  }
}

function checkWebp() {
  const canvas = document.createElement("canvas");

  if (canvas.getContext?.("2d")) {
    // was able or not to get WebP representation
    return canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
  }

  // canvas not supported, webp not supported either.
  return false;
}

/**
 * Handles feature detection once per pageload. Ensures expensive detections will not be run once.
 */
const plugin: Plugin = (context, inject) => {
  const defaultPixelRatio = 3;
  const features: FeatureDetection = {
    webp: false,
    dpr: 1,
    clipboard: false,
  };

  features.clipboard = process.client ? Boolean(navigator.clipboard) : false;
  features.dpr =
    (process.server
      ? undefined
      : window.devicePixelRatio > defaultPixelRatio
      ? defaultPixelRatio
      : window.devicePixelRatio) ?? 1;

  if (process.server) {
    const accepts = context.ssrContext?.req?.headers?.accept ?? "";
    features.webp = accepts.split(",").includes("image/webp");
  } else {
    features.webp = checkWebp();
  }

  inject("featureDetection", features);
  context.$featureDetection = features;
};

export default plugin;
